import React, { lazy, useContext } from "react";

import Loadable from "./Loadable";
import AppContext from "@context";
import StepPlansVD from "@/features/Comprar/vida-devolucion/step-plans/page";
import StepDataVD from "@/features/Comprar/vida-devolucion/step-data/page";
import StepPaymentVD from "@/features/Comprar/vida-devolucion/step-payment/page";
import StepPlansVE from "@/features/Comprar/vida-endosable/step-plans/page";
import StepDataVE from "@/features/Comprar/vida-endosable/step-data/page";
import StepPaymentVE from "@/features/Comprar/vida-endosable/step-payment/page";

// Pages Vida Devolucion
const StepInitialVD = Loadable(
  lazy(() => import("../features/Comprar/vida-devolucion/step-initial/page"))
);
const StepPersonalDataVD = Loadable(
  lazy(() =>
    import("../features/Comprar/vida-devolucion/step-personal-data/page")
  )
);
const StepFinalVD = Loadable(
  lazy(() => import("../features/Comprar/vida-devolucion/step-final/page"))
);
const StepThankYouVD = Loadable(
  lazy(() => import("../features/Comprar/vida-devolucion/step-thank-you/page"))
);
const StepErrorVD = Loadable(
  lazy(() => import("../features/Comprar/vida-devolucion/step-error/page"))
);

// Pages Vida Plus
const StepInitialVP = Loadable(
  lazy(() => import("../features/Comprar/vida-plus/step-initial/page"))
);
const StepPlansVP = Loadable(
  lazy(() => import("../features/Comprar/vida-plus/step-plans/page"))
);
const StepPersonalDataVP = Loadable(
  lazy(() => import("../features/Comprar/vida-plus/step-personal-data/page"))
);
const StepPaymentVP = Loadable(
  lazy(() => import("../features/Comprar/vida-plus/step-payment/page"))
);
const StepThankYouVP = Loadable(
  lazy(() => import("../features/Comprar/vida-plus/step-thank-you/page"))
);
const StepErrorVP = Loadable(
  lazy(() => import("../features/Comprar/vida-plus/step-error/page"))
);

// Pages Viajes
const StepInitialT = Loadable(
  lazy(() => import("../features/Comprar/viajes/step-initial/page"))
);
const StepPlansT = Loadable(
  lazy(() => import("../features/Comprar/viajes/step-plans/page"))
);
const StepDataT = Loadable(
  lazy(() => import("../features/Comprar/viajes/step-data/page"))
);
const StepPaymentT = Loadable(
  lazy(() => import("../features/Comprar/viajes/step-payment/page"))
);
const StepThankYouT = Loadable(
  lazy(() => import("../features/Comprar/viajes/step-thank-you/page"))
);

// Pages Vida Endosable
const StepInitialVE = Loadable(
  lazy(() => import("../features/Comprar/vida-endosable/step-initial/page"))
);
const StepPersonalDataVE = Loadable(
  lazy(() =>
    import("../features/Comprar/vida-endosable/step-personal-data/page")
  )
);
const StepThankYouVE = Loadable(
  lazy(() => import("../features/Comprar/vida-endosable/step-thank-you/page"))
);
const StepFinalVE = Loadable(
  lazy(() => import("../features/Comprar/vida-endosable/step-final/page"))
);
const StepErrorVE = Loadable(
  lazy(() => import("../features/Comprar/vida-endosable/step-error/page"))
);
const StepSuscriptionVE = Loadable(
  lazy(() => import("../features/Comprar/vida-endosable/step-suscription/page"))
);

function filter_props(contextProps, filterModel) {
  if (!contextProps || !filterModel) {
    return;
  }

  let filterProps = contextProps.filter((o, i) => {
    return Object.keys(o)[0] === filterModel;
  });

  if (filterProps.length === 0) {
    return {};
  }
  filterProps = filterProps[0][filterModel];

  return filterProps.length !== 0 ? filterProps : {};
}

const ResponsiveGrid = (props) => props.children;

const KeysToComponentMap = {
  root: ResponsiveGrid,
  responsivegrid: ResponsiveGrid,
  responsivegrid_17203: ResponsiveGrid,
  responsivegrid_123: ResponsiveGrid,

  vd_step_initial: StepInitialVD,
  vd_step_personal_data: StepPersonalDataVD,
  vd_step_plans: StepPlansVD,
  vd_step_data: StepDataVD,
  vd_step_payment: StepPaymentVD,
  vd_step_final: StepFinalVD,
  vd_step_thank_you: StepThankYouVD,
  vd_step_error: StepErrorVD,
  vp_step_initial: StepInitialVP,
  vp_step_plans: StepPlansVP,
  vp_step_personal_data: StepPersonalDataVP,
  vp_step_payment: StepPaymentVP,
  vp_step_thank_you: StepThankYouVP,
  vp_step_error: StepErrorVP,
  trips_step_initial: StepInitialT,
  trips_step_plans: StepPlansT,
  trips_step_data: StepDataT,
  trips_step_payment: StepPaymentT,
  trips_step_thank_you: StepThankYouT,
  ve_step_initial: StepInitialVE,
  ve_step_plans: StepPlansVE,
  ve_step_personal_data: StepPersonalDataVE,
  ve_step_thank_you: StepThankYouVE,
  ve_step_data: StepDataVE,
  ve_step_payment: StepPaymentVE,
  ve_step_final: StepFinalVE,
  ve_step_error: StepErrorVE,
  ve_step_suscription: StepSuscriptionVE,
};

function createComponent(type) {
  return React.createElement(
    KeysToComponentMap[type.component],
    type.props,
    type?.children && typeof type?.children === "string"
      ? type?.children
      : type?.children.map((children) => renderer(children))
  );
}
function renderer(type) {
  if (typeof type.children === "undefined") {
    type.children = [];
  }
  if (typeof KeysToComponentMap[type.component] !== "undefined") {
    return typeof type.gridClassNames !== "undefined" ? (
      type.component === "responsivegrid_17203" ||
      type.component === "responsivegrid_123" ? (
        <div>
          <div className={type.gridClassNames}>{createComponent(type)}</div>
        </div>
      ) : (
        <div className={type.gridClassNames}>{createComponent(type)}</div>
      )
    ) : (
      createComponent(type)
    );
  }
}

const FindModel = (type) => {
  const contextValue = useContext(AppContext);

  if (typeof filter_props(contextValue, type) === "undefined") {
    return <></>;
  }

  return renderer(filter_props(contextValue, type));
};

export default FindModel;
